import React, {useState, useContext, useEffect} from 'react';
import {texts, properties} from './DesistimientoData';
import AppContext from 'AppContext';
import { useHistory } from "react-router-dom";
import {properties as appProperties} from 'AppData';
import {loadState, saveState} from '../../../providers/localStorage';
import useApp from 'AppFunctions';
import {localStorageName} from '../../../providers/localStorageData';
import RestProvider from 'providers/RestProvider';
import useSmsSignFunction from 'SmsSign/useSmsSignFunction';
import useFunctions from '../firmaSolicitud/FirmaSolicitudFunction';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';

const useFunctionsDesestimiento = () => {
    const { presentarSolicitudPct3 } = useFunctions();
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const fase = useSelector((state) => state.kingdomOV3.fase);
    const estado = useSelector((state) => state.kingdomOV3.estado);

    const dispatch = useDispatch();

    const { validarCodigoSms } = useSmsSignFunction();

    /**
    * @function obtenerProcedenciaConvocatoria Obtiene la procedencia de una convocatoria (PCT2 o PCT3)
    */
     const obtenerProcedenciaConvocatoria = () => {
        return (procedimientoActual.fromPct3 !== undefined && procedimientoActual.fromPct3 === true) ? 'PCT3' : 'PCT2';
    }

    let procedenciaConvocatoria = obtenerProcedenciaConvocatoria();

    const {firmarGenerico, calcularDataSource, calcularHashBase64, obtenerTipoFirma} = useApp();

    let documentoInicial = {
        mostrarDropZone: true,
        value: texts.TEXT_DOC,
        mostrarDocAnexo: false,
        tamDoc: "",
    }

    //Hooks
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [tamMaximoSobrepasado, setTamMaximoSobrepasado] = useState(false);
    const [documentos] = useState([]);
    const [documentosDesistir, setDocumentosDesistir] = useState([documentoInicial]);
    const [errorDropRejected, setErrorDropRejected] = useState(false);
    const [tamDropRejected, setTamDropRejected] = useState("");
    const [disabledBotonFirmar, setDisabledBotonFirmar] = useState(true);
    const [pdf, setPdf] = useState(null);  
    const [filePdf, setFilePdf] = useState(null);
    const [mostrarConfirmarFirma, setMostrarConfirmarFirma] = useState(false);
    const [mostrarErrorPresentacion, setMostrarErrorPresentacion] = useState(false);
    const [msgErrorPresentacion, setMsgErrorPresentacion] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [mostrarPopUpDesOk, setMostrarPopUpDesOk] = useState(false);
    const {crudOperation, crudOperationsType} = RestProvider();
    const [isProcessingFirma, setIsProcessingFirma] = useState(false);

    const context = useContext(AppContext);
    const history = useHistory();
    const PREFIJO_OBJETO_FILE_PDF = 'data:application/pdf;base64,';

    let arrayVoluntariosTmp;

    useEffect(() => {
        arrayVoluntariosTmp = documentosDesistir;
    }, [documentosDesistir]) ;

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
     const obtenerTituloPagina = () =>{
        context.updateTitlePage(texts.PAGE_TITLE);
    }

    /**
     * Volver a la bandeja de entrada
     */
     const volverABandeja = () =>{
        history.push(properties.URL_BANDEJA)
    }

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
     const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    //Metodo para mostrar el confirmar
    const mostrarConfirmacion = () => {
        setMostrarConfirmarFirma(true);
    }

    //Metodo para dejar de motrar el componente confirmar
    const dejarDeMostrarConfirmacion = () => {
        setMostrarConfirmarFirma(false);
    }

    /**
     * @function handleOnDrop Gestion de la subida de documentos
     * @param {*} files Fichero subido por el usuario
     * @param {*} rejectedFiles Fichero rechazado subido por el usuario
     */
     const handleOnDrop = (files, rejectedFiles) => {

        var tamFicheroSubido = parseFloat((files[0].file.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));

        if(properties.TAM_MAX_ANEXO < tamFicheroSubido){
            setTamMaximoSobrepasado(true);
        } else {
            let documentoV = {
                fichero: files[0],
                anexo: null,
                descripcionVoluntario: documentosDesistir[0].value,
                firmado: false,
                nombreFichero: {...files[0].file},
                idSolicitud: null, // <---Por definir
                idConvocatoria: null, // <---Por definir
                idProcedimiento: null, // <---Por definir
            }
            documentoV.fichero.data = files[0].data.split('base64,')[1];
            setPdf(procedenciaConvocatoria === 'PCT2' ? files[0].data : documentoV);
            setFilePdf(procedenciaConvocatoria === 'PCT2' ? files[0].data : PREFIJO_OBJETO_FILE_PDF + documentoV.fichero.data);
            documentos.push(documentoV);

            const arrayTemp = [...documentosDesistir];

            arrayTemp[0].mostrarDocAnexo = true;
            arrayTemp[0].tamDoc = tamFicheroSubido;
            arrayTemp[0].mostrarDropZone = false;

            setDocumentosDesistir(arrayTemp);
            setDisabledBotonFirmar(false);

        }
        
    }

    /**
    * @function eliminarAnexo Metodo que elimina el anexo adjuntado
    * @param {*} e Fichero subido por el usuario
    */
    const eliminarAnexoVoluntario = (e) => {

        const arrayTemp = [...documentosDesistir];

        arrayTemp[0].mostrarDropZone = true;
        arrayTemp[0].mostrarDocAnexo = false;
        arrayTemp[0].tamDoc = "";

        setDocumentosDesistir(arrayTemp);
        setDisabledBotonFirmar(true);
        setPdf(null);

        documentos.splice(0, 1);

    };

    /**
     * @function mostrarConfirmarError Metodo que hace saltar el componente mostrar cuando un anexo subido es rechazado
     * @param {*} rejectedFile Fichero rechazado
     * @param {*} tamMaxDoc tamaño maximo permitido para el documento
     */
     const mostrarConfirmarError = (rejectedFile, tamMaxDoc) => {

        setErrorDropRejected(true);
        setTamDropRejected(tamMaxDoc);
    };

    /**
     * @function cerrarErrorDropRejected Metodo que cierra el componente mostrar cuando un anexo subido es rechazado
     */
     const cerrarErrorDropRejected = () => {

        setErrorDropRejected(false);
        
    };

    /**
     * @function accionFirmar Metodo que realiza la accion de firmar
     */
     const accionFirmar = () => {
        dejarDeMostrarConfirmacion();
        let doc = procedenciaConvocatoria === 'PCT2' ? pdf : pdf.fichero.data;
        firmarGenerico(doc, presentarDesistimiento, null, procedenciaConvocatoria);
        
    };

    //PRESENTAR DESESTIMIENTO
    const presentarDesistimiento = async (signatureBase64, certificate864) => {
        procedenciaConvocatoria === 'PCT2' ? await presentarDesistimientoPCT2(signatureBase64, certificate864) : presentarDesestimientoPct3(signatureBase64, certificate864);
    }

    const presentarDesistimientoPCT2 = async (signatureBase64, certificate864) => {
        let inputPresentarDesistimiento =  montarInputPresentarDesistimiento(signatureBase64);

        setIsLoading(true);

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_DESISTIMIENTO, {url:properties.URL_PRESENTAR_DESISTIMIENTO, method: 'post', data:inputPresentarDesistimiento}).then(response => {                
            setIsLoading(false)
            setMostrarPopUpDesOk(true);
        }).catch(function (error) {
            setIsLoading(false)
            if(error.response){
                let msg = error.response.data.messageDescription;
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            }else{       
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR);
            }    
            setMostrarErrorPresentacion(true);
            tramitarExpedienteDesestimiento();
        }); 
    }

     //Tramitar expediente y ultima resolución
     const tramitarExpedienteDesestimiento =  async (signatureBase64, certificate864) => {
        let inputPresentarDesistimiento =  montarInputPresentarDesistimiento(signatureBase64);

        setIsLoading(true)

        let idExpediente = inputPresentarDesistimiento.idExpTrewa;
        let expediente;

         //Paso 1.Tramitar expediente a fase desestimiento y tramitar resolución
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: properties.URL_ACCION_PRESENTAR_DESEST_OV3 + idExpediente, method: 'post'}).then(response => {

            expediente = response.data;      
            //Paso 2.2. Se inserta el mensaje de éxito
            console.log(expediente);
            setIsLoading(false)
            setMostrarPopUpDesOk(true);
        }).catch(function (error) {
            setIsLoading(false)
            if(error.response){
                let msg = error.response.data.messageDescription;
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            }else{       
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR);
            }    
            setMostrarErrorPresentacion(true);
        })
    }

    //PRESENTAR DESISTIMIENTO PCT3
    const presentarDesestimientoPct3 = async (signatureBase64, certificate864) => {
        let inputPresentarSolicitudPct3 =  await montarInputPresentarDesestimientoPct3(signatureBase64);
        setIsLoading(true);
        setIsProcessingFirma(true);
        
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_DESESTIMIENTO_PCT3, {url:'', method: 'post', data:inputPresentarSolicitudPct3}).then(response => {       
            
            dispatch(insertNewState({filnedName: 'numRegistroAries', value: response.data.numRegistroAries}));
            dispatch(insertNewState({filnedName: 'recibi', value: response.data.recibi}));
            dispatch(insertNewState({filnedName: 'numeroExpediente', value: response.data.numeroExpediente}));
            dispatch(insertNewState({filnedName: 'idExpediente', value: response.data.idExpediente}));

            setIsLoading(false);
            setMostrarPopUpDesOk(true);
            

        }).catch(function (error) {
            setIsLoading(false);
            if(error.response){
                let msg = error.response.data.messageDescription;     
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            }else{
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR); 
            }   
            
            setMostrarErrorPresentacion(true);
        })
    }

    const dejarDeMostrarErrorPresentacion = () => {
        setMostrarErrorPresentacion(false);
    }

    const montarInputPresentarDesistimiento = (firma) => {

        let inputPresentarDesistimiento = {
            dataSource: calcularDataSource(procedimientoActual.codigoAplicacion),
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null ,
            isloginCertificadoDigital: infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            listadoDocumentosEntregaDTO: montarDocumentosEntrega(firma),
            organismo:"A01004509", //TODO
            idProcedimiento: procedimientoActual.id,
            cdProcTrewa: convocatoriaSeleccionada.cdProcTrewa,
            descripcionProcedimiento: procedimientoActual.descripcion,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            codigoSistemaTrewa: procedimientoActual.cdSistemaTrewa,
            usuarioTrewa: perfilSeleccionado.cdUsuarioTrewa,
            tipoExpedienteTrewa: convocatoriaSeleccionada.cdTipoExpTrewa,
            fechaInicioPresentacion: new Date(convocatoriaSeleccionada.fechaInicioPresentacion),
            fechaFinPresentacion: new Date(convocatoriaSeleccionada.fechaFinPresentacion),
            enumProcesoEntrega: "DESISTIMIENTO",
            idMoaddSolicitudesPDF: solicitudActual.idSolicitud,
            idAplicacion: procedimientoActual.codigoAplicacion,
            idExpTrewa: solicitudActual.idExpediente, //TODO
        }
        
        return inputPresentarDesistimiento;
    }

    const montarInputPresentarDesestimientoPct3 = async (firma) => {
        let enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_DESISTIMIENTO;
        let estadoAndFase = await obtenerCodFaseCodEstado(solicitudActual.idExpediente);
  
        let inputPresentarSolicitud = {
            enumProcesoEntrega: enumeradoProcesoEntrega,
            idExpediente: solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id, 
            numeroExpediente: solicitudActual.numeroExpediente,
            idConvocatoria:convocatoriaSeleccionada.id,
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null ,
            isloginCertificadoDigital:infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            fechaInicioPresentacion:new Date(convocatoriaSeleccionada.fechaInicioPresentacion),
            fechaFinPresentacion: new Date(convocatoriaSeleccionada.fechaFinPresentacion),
            idProcedimiento: procedimientoActual.id,
            descripcionProcedimiento: procedimientoActual.descripcion,
            usuarioAries: convocatoriaSeleccionada.codAriesUsuario,
            passwordAries:convocatoriaSeleccionada.codAriesPassword,
            asuntoAries: convocatoriaSeleccionada.codAriesAsunto,
            destinatarioAries: convocatoriaSeleccionada.codAriesDestinatario,
            listDocumentos: montarDocumentosEntrega(firma), //TODO
            fase: estadoAndFase.fase.codigo,
            estado: estadoAndFase.estado.codigo,
            enumTipoFirma: obtenerTipoFirma(),
            perfil: perfilSeleccionado
        }
        
        return inputPresentarSolicitud;
    }

    const montarDocumentosEntrega = (firma) => {
        let arrayDocumentoEntrega = new Array(documentos.length);
        let documentoEntrega;

        documentoEntrega = {
            firmaBase64: firma,
            hashDocumentoBase64: calcularHashBase64(pdf),
            documento: documentos[0].fichero.data,
            nombreDocumento: documentos[0].descripcionVoluntario,
            tipoDocumento: "DESISTIMIENTO", 
            descripcionDocumento: documentos[0].descripcionVoluntario,
            firmado: true
           }
                
        arrayDocumentoEntrega[0] = documentoEntrega;
          
        return  arrayDocumentoEntrega;
    }

    /**
     * @function obtenerCodFaseCodEstado Función que obtiene el objeto fase y el objeto estado a través del idExpediente
     * @param {*} idExpediente 
     * @returns 
     */
    const obtenerCodFaseCodEstado = async (idExpediente) => {
        let expediente = null, fase = null, estado = null, res = null;

        // Paso 1. Obtención del expediente
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: `/ov3/${idExpediente}`, method: 'get' }).then(response => {                
            expediente = response.data;
        }).catch(function (error) {
            setMsgErrorPresentacion('Se ha producido un error al obtener el expediente');
        });

        // Paso 2. Obtención del idFase y del idEstado actual del expediente
        let idFase = expediente.objetosTramitables[0].idFaseActual;
        let idEstado = expediente.objetosTramitables[0].idEstadoFaseActual;

        // Paso 3. Obtención de la fase
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FASE, { url: `/${idFase}`, method: 'get' }).then(response => {                
            fase = response.data;
        }).catch(function (error) {
            setMsgErrorPresentacion('Se ha producido un error al obtener la fase');
        });

        // Paso 4. Obtención del estado
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ESTADO_FASE, { url: `/${idEstado}`, method: 'get' }).then(response => {                
            estado = response.data;
        }).catch(function (error) {
            setMsgErrorPresentacion('Se ha producido un error al obtener el estado');
        });

        res = {
            fase: fase,
            estado: estado
        };

        return res;
    }

    return {isPhoneVersion, obtenerTituloPagina, updateFormat, handleOnDrop, documentosDesistir, eliminarAnexoVoluntario, mostrarConfirmarError,
        cerrarErrorDropRejected, errorDropRejected, tamDropRejected, tamMaximoSobrepasado, volverABandeja, disabledBotonFirmar, accionFirmar,
        pdf, mostrarConfirmacion, dejarDeMostrarConfirmacion, mostrarConfirmarFirma, isLoading, mostrarErrorPresentacion,
        msgErrorPresentacion, dejarDeMostrarErrorPresentacion, mostrarPopUpDesOk, isProcessingFirma, filePdf, presentarDesestimientoPct3};

}
export default useFunctionsDesestimiento;